<section>
  <div class="d-flex justify-content-end close" (click)="closeBottomSheet()" *ngIf="isMobile"><i
      class="far fa-times-circle"></i>
  </div>
  <div class="d-flex justify-content-end close" (click)="closeDialog()" *ngIf="!isMobile"><i
      class="far fa-times-circle"></i>
  </div>
  <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmitLogin()">
    <span class="login100-form-title pb-2">
      <span *ngIf="isSignup">Sign Up</span>
      <span *ngIf="!isSignup">Login</span>
    </span>

    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" />
          <mat-icon matSuffix>face</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12col-lg-12 col-md-12 col-sm-12 mb-2">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" formControlName="password">
          <!-- <a class="show-pwd-icon" href="#" onClick="return false;" matSuffix (click)="hide = !hide"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide"> -->
          <mat-icon (click)="hide = !hide" matSuffix>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          <!-- </a> -->
        </mat-form-field>
      </div>
    </div>

  </form>

  <div class="container-login100-form-btn">
    <button mat-flat-button color="primary" class="login100-form-btn" type="submit" (click)="onSubmitLogin()">
      <span *ngIf="isSignup">Sign Up</span>
      <span *ngIf="!isSignup">Login</span>
    </button>
  </div>
  <div class="flex-sb-m w-full p-t-5 p-b-5">
    <div>
      <a class="txt1" routerLink="/authentication/forgot-password">Forgot Password?</a>
    </div>
  </div>
  <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
  <div class="hrContainer m-t-5">
    <span class="orHR">or</span>
  </div>
  <div class="text-center p-t-30 p-b-20">
    <h3>Access Code</h3>
    <input [(ngModel)]="accessCode" />
  </div>
  <div class="text-center p-t-30 p-b-20">

    <div class="login100-form-social flex-c-m">
      <button class="facebook-btn social-btn" (click)="submitFacebook()">
        <div class="social-btn-inner">
          <div class="social-btn-icon">
            <i class="fab fa-facebook-f"></i>
          </div>
          <div class="social-btn-text">Log in with Facebook</div>
        </div>
      </button>
    </div>
    <br />
    <div class="login100-form-social flex-c-m">
      <button class="google-btn social-btn " (click)="submitGoogle()">
        <div class="social-btn-inner">
          <div class="social-btn-icon"><i class="fab fa-google-plus-g"></i></div>
          <div class="social-btn-text"> Log in with Google</div>
        </div>
      </button>

    </div>

  </div>
</section>
<ngx-spinner bdColor="rgb(255 255 255 / .02)" size="medium" color="#0af0d5" type="ball-scale-pulse" [fullScreen]="false"
  [name]="'authSpinner'">
  <h4 style="color: #6c757d">Authenticating</h4>
</ngx-spinner>